import { render, staticRenderFns } from "./ReInputContactSimple.vue?vue&type=template&id=00b97e84&scoped=true"
import script from "./ReInputContactSimple.vue?vue&type=script&lang=js"
export * from "./ReInputContactSimple.vue?vue&type=script&lang=js"
import style0 from "./ReInputContactSimple.vue?vue&type=style&index=0&id=00b97e84&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00b97e84",
  null
  
)

export default component.exports